import { BLOCK_BY, BLOCK_DATE } from "../consts";

import { z } from "zod";
import { PAYMENT_BLOCK } from "../consts";

export const schema = z.object({
  [PAYMENT_BLOCK]: z.boolean().optional(),
  [BLOCK_DATE]: z.string().optional(),
  [BLOCK_BY]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
